import { useAppSelector } from 'store/store';
import { useLocation, Navigate, Outlet } from 'react-router-dom';

const RequireAuth = () => {
  const access = useAppSelector((state) => state.auth.user);
  const location = useLocation();
  return access ? <Outlet /> : <Navigate to="/login" state={{ from: location }} replace />;
};
export default RequireAuth;
